<h3>Supported Libraries</h3>

<capra-search-input
  *ngIf="!(isInCleanSlateMode$ | async)"
  placeholder="Search libraries..."
  class="max-width"
  size="mini"
  [text]="searchTerm$ | async"
  (textChange)="handleSearchLibrariesChanged($event)"
>
</capra-search-input>

<!-- Search Results -->
<ng-container *ngIf="hasSearchTerm$ | async">
  <div class="section-container search-results">
    <div *ngIf="(searchResults$ | async)?.length === 0" class="no-results">
      No libraries found.
      <p class="no-result-public-link-text">
        Don’t see the library you’re looking for? Or looking to use a specific version of library? Refer to our
        <a href="https://mode.com/help/articles/notebook#install-additional-libraries" target="_blank">documentation</a>
        to learn how to use the <code>pip</code> command to customize the libraries for your current Notebook session.
      </p>
    </div>

    <ul class="section-list">
      <li *ngFor="let result of searchResults$ | async">
        <a [href]="" target="_blank">{{ result.label }}</a
        >: <span [innerHtml]="result.description"></span>
      </li>
    </ul>
  </div>
</ng-container>

<!-- All Libraries -->
<ng-container *ngIf="!(hasSearchTerm$ | async) && !(isInCleanSlateMode$ | async); else listView">
  <div
    class="section-container"
    *ngFor="let group of groupedLibraries$ | async | modeNotebookSortLibraryGroups"
    [class.--collapsed]="isSectionOpen(group.key)"
  >
    <p class="section-title" (click)="toggleSection(group.key)">
      <capra-icon icon="icon-chevron-down"></capra-icon>{{ group.label }}
    </p>

    <ul class="section-list">
      <li *ngFor="let library of group.libraries | orderBy: 'label'">
        <a [href]="library.href" target="_blank">{{ library.label }}</a
        >: <span [innerHtml]="library.description"></span>
      </li>
    </ul>
  </div>
</ng-container>

<ng-template #listView>
  <ul class="section-list">
    <li *ngFor="let library of libraries$ | async | orderBy: 'label'">
      <a [href]="library.href" target="_blank">{{ library.label }}</a>:
      <span [innerHtml]="library.description"></span>
    </li>
  </ul>
</ng-template>

<h3>Gallery</h3>

<p class="notebook-sidebar-text">
  <a target="_blank" href="https://mode.com/example-gallery/">{{ appName }} Gallery</a>: Browse templates for common
  analytical tasks using Python, R, and HTML
</p>

<p class="notebook-sidebar-text notebook-package-install">
  <ng-container [ngSwitch]="environment">
    <ng-container *ngSwitchCase="'r'">
      Don't see the package you're looking for? Use the <code>install</code> command to add a public package to your
      current Notebook session.
    </ng-container>

    <ng-container *ngSwitchDefault>
      Don’t see the library you’re looking for? Use
      <span *ngIf="environment === 'python'">Python 3 to access</span> the <code>pip</code> command and add public
      libraries to your current Notebook session.
    </ng-container>

    <a
      target="_blank"
      [attr.href]="helpDocs.links['https://mode.com/help/articles/notebook/#install-additional-libraries']"
      >Learn more</a
    >
  </ng-container>
</p>
